import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { utilRange } from '../../../../services/utils/utils.service'
import SelectableListComponent from '../../../shared/selectable-list.component'

export default function CastingQuantityPickerComponent ({ store, data: { offeredService: os, quantity } }: StoreProps) {
  return <SelectableListComponent
    name="castingQuantity"
    data={ utilRange(os.quantity_min, os.quantity_max + 0.01, os.quantity_step) }
    value={ quantity }
    formatter={ val => val.toString() }
    onChange={ val => { store.set({ quantity: val }); store.nextFocus({ closeOnMobile: true }) } } />
}
